import { render, staticRenderFns } from "./ProformaInvoiceAttachmentDialog.vue?vue&type=template&id=f2086b86"
import script from "./ProformaInvoiceAttachmentDialog.vue?vue&type=script&lang=js"
export * from "./ProformaInvoiceAttachmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports